export default function useGa() {
    function gaTracking(_trackpage){
        window.gtag('event', 'click', {
            event_category: _trackpage,
            event_label: 'Google',
        });
        // console.log(_trackpage);
    }

    return gaTracking;
}